var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShoppingCart3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19_117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.90457 16.5C8.38635 16.5 8.77691 16.1642 8.77691 15.75C8.77691 15.3358 8.38635 15 7.90457 15C7.42279 15 7.03223 15.3358 7.03223 15.75C7.03223 16.1642 7.42279 16.5 7.90457 16.5Z",
    stroke: "#DF0915",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5003 16.5C17.982 16.5 18.3726 16.1642 18.3726 15.75C18.3726 15.3358 17.982 15 17.5003 15C17.0185 15 16.6279 15.3358 16.6279 15.75C16.6279 16.1642 17.0185 16.5 17.5003 16.5Z",
    stroke: "#DF0915",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.925781 0.75H4.41514L6.75301 10.7925C6.83279 11.1378 7.05128 11.448 7.37024 11.6687C7.6892 11.8895 8.0883 12.0067 8.4977 12H16.9768C17.3862 12.0067 17.7853 11.8895 18.1043 11.6687C18.4233 11.448 18.6418 11.1378 18.7215 10.7925L20.1173 4.5H5.28748",
    stroke: "#DF0915",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19_117"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.9362,
    height: 18,
    fill: "white",
    transform: "translate(0.0537109)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart3);
export default __webpack_public_path__ + "static/media/shopping-cart_3.ebf4b1b06c03337abb5d473a05e80cc1.svg";
export { ForwardRef as ReactComponent };